import { FormProvider } from 'react-hook-form'
import { BasicInput } from '../../components/BasicInput'
import { Button } from '../../components/ui/button'
import { phoneMask } from '../../../app/utils/phoneFormater'
import { cpfMask } from '../../../app/utils/cpfFormater'
import { ArrowRight2 } from 'iconsax-react'
import { useInviteController } from './useInviteController'
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/view/components/ui/alert-dialog'
import { Spinner } from '@/view/components/ui/spinner'
import { QRCodeWithLogo } from '../../components/QRCode/QRCode'
import invite from '../../../assets/invite.png'

export function InvitePage() {
  const { errors, onSubmit, form, modalState, onOpenLink, banners, isLoading } =
    useInviteController()
  const { modalOpen, setModalOpen } = modalState

  const banner = banners?.banners.find((banner) => banner.isWebApp)

  const registerUrl = import.meta.env.VITE_TEAMS_URL.replace(
    '/invite/',
    '/register/',
  )

  const googlePlayUrl =
    import.meta.env.VITE_GOOGLE_URL &&
    import.meta.env.VITE_GOOGLE_URL.trim() !== ''
      ? import.meta.env.VITE_GOOGLE_URL
      : null

  const appleStoreUrl =
    import.meta.env.VITE_APPLE_URL &&
    import.meta.env.VITE_APPLE_URL.trim() !== ''
      ? import.meta.env.VITE_APPLE_URL
      : null

  const showGooglePlayQR = !!googlePlayUrl
  const showAppleStoreQR = !!appleStoreUrl

  const qrCodeCount = [showGooglePlayQR, showAppleStoreQR, true].filter(
    Boolean,
  ).length

  return (
    <>
      <AlertDialog open={modalOpen} onOpenChange={setModalOpen}>
        <AlertDialogContent
          className={`max-h-[90vh] w-[95vw] overflow-y-auto ${
            qrCodeCount === 1
              ? 'max-w-md'
              : qrCodeCount === 2
                ? 'max-w-2xl'
                : 'max-w-4xl'
          }`}
        >
          <AlertDialogHeader className="p-2">
            <AlertDialogTitle className="text-center text-xl">
              Agora você já pode usar o App {import.meta.env.VITE_COMPANY}
            </AlertDialogTitle>
          </AlertDialogHeader>
          <div className="border-b-[1px] border-white02" />
          <p className="mb-2 text-center">
            Escaneie o QRcode ou clique abaixo para baixar o aplicativo{' '}
            {import.meta.env.VITE_COMPANY} no seu celular e finalize o cadastro.
          </p>

          <div
            className={`flex gap-4 max-sm:flex-col max-sm:gap-6 ${
              qrCodeCount === 1
                ? 'justify-center'
                : qrCodeCount === 2
                  ? 'justify-center'
                  : 'justify-between'
            }`}
          >
            {showGooglePlayQR && (
              <div
                className={`flex flex-1 flex-col items-center gap-4 max-sm:max-w-full ${
                  qrCodeCount === 1 ? 'max-w-[280px]' : 'max-w-[300px]'
                }`}
                onClick={() => onOpenLink(googlePlayUrl)}
              >
                <QRCodeWithLogo
                  value={googlePlayUrl}
                  size={200}
                  logoSize={40}
                  title="Google Play Store QR Code"
                  className="max-sm:!h-[150px] max-sm:!w-[150px]"
                />
                <img
                  src="/google_badge.svg"
                  alt=""
                  className="mt-auto max-w-[70%] cursor-pointer object-cover max-sm:max-w-[60%]"
                />
              </div>
            )}
            {showAppleStoreQR && (
              <div
                className={`flex flex-1 flex-col items-center gap-4 max-sm:max-w-full ${
                  qrCodeCount === 1 ? 'max-w-[280px]' : 'max-w-[300px]'
                }`}
                onClick={() => onOpenLink(appleStoreUrl)}
              >
                <QRCodeWithLogo
                  value={appleStoreUrl}
                  size={200}
                  logoSize={40}
                  title="Apple App Store QR Code"
                  className="max-sm:!h-[150px] max-sm:!w-[150px]"
                />
                <img
                  src="/apple_badge.svg"
                  alt=""
                  className="mt-auto max-w-[70%] cursor-pointer object-cover max-sm:max-w-[60%]"
                />
              </div>
            )}
            <div
              className={`flex flex-1 flex-col items-center gap-4 max-sm:max-w-full ${
                qrCodeCount === 1 ? 'max-w-[280px]' : 'max-w-[300px]'
              }`}
              onClick={() => onOpenLink(registerUrl, true)}
            >
              <QRCodeWithLogo
                value={registerUrl}
                size={200}
                logoSize={40}
                title="Register URL QR Code"
                className="max-sm:!h-[150px] max-sm:!w-[150px]"
              />
              <img
                src="/badge_web.svg"
                alt=""
                className="max-w-[70%] cursor-pointer object-cover max-sm:max-w-[60%]"
              />
            </div>
          </div>
        </AlertDialogContent>
      </AlertDialog>

      <main className="flex h-screen">
        <FormProvider {...form}>
          <form
            className="flex h-screen w-full flex-col justify-evenly gap-8 px-8 py-16 min-[1040px]:w-[650px] "
            onSubmit={onSubmit}
          >
            <div className="flex flex-col gap-8">
              <div>
                <h2 className="text-2xl font-semibold">Vamos começar?</h2>
                <p className="text-sm text-black03">
                  Dê o primeiro passo em direção a liberdade financeira
                </p>
              </div>
              <div className="flex items-center justify-between gap-4">
                <div className="flex grow flex-col gap-4">
                  <BasicInput
                    name="name"
                    label="Nome completo"
                    labelClass="text-md"
                    sizeInput="large"
                    placeholder="Digite seu nome"
                    error={errors.name?.message}
                  />

                  <BasicInput
                    name="email"
                    label="E-mail"
                    labelClass="text-md"
                    sizeInput="large"
                    placeholder="email@example.com"
                    error={errors.email?.message}
                  />

                  <BasicInput
                    sizeInput="large"
                    name="phone"
                    label="Número de telefone"
                    labelClass="text-md"
                    placeholder="(00) 99999-9999"
                    error={errors.phone?.message}
                    onInput={phoneMask}
                  />

                  <BasicInput
                    name="cpf"
                    label="CPF"
                    placeholder="000.000.000-00"
                    labelClass="text-md"
                    sizeInput="large"
                    error={errors.cpf?.message}
                    onInput={cpfMask}
                  />
                </div>
                <div className="hidden h-[460px] bg-background pr-4 min-[865px]:flex min-[1040px]:hidden ">
                  {!isLoading &&
                    (banner ? (
                      <img
                        src={`${import.meta.env.VITE_CDN_URL}${banner.uri}`}
                        alt=""
                        className="object-scale-down"
                      />
                    ) : (
                      <img src={invite} alt="" className="object-scale-down" />
                    ))}
                  {isLoading && <Spinner />}
                </div>
              </div>
            </div>
            <Button
              type="submit"
              className="rounded-full p-8 text-xl font-semibold text-white"
            >
              Baixar o APP
              <ArrowRight2 />
            </Button>
          </form>
        </FormProvider>
        <div className="hidden h-screen grow bg-background p-4 min-[1040px]:flex ">
          {!isLoading &&
            (banner ? (
              <img
                src={`${import.meta.env.VITE_CDN_URL}${banner.uri}`}
                alt=""
                className="h-full w-full object-scale-down xl:object-fill "
              />
            ) : (
              <img
                src={invite}
                alt=""
                className="h-full w-full object-scale-down xl:object-fill "
              />
            ))}
          {isLoading && <Spinner />}
        </div>
      </main>
    </>
  )
}
